<div *ngIf="!!url;then with_link else without_link"></div>
<ng-template #with_link>
  <app-elearnio-mat-table-link
    [text]="text"
    [url]="url"
    [state]="state"
  ></app-elearnio-mat-table-link>
</ng-template>

<ng-template #without_link>
  <span class="without-link" [class.archived]="state === TrainingAvailability.ARCHIVED || state === TrainingAvailability.DRAFT">
    <mat-icon *ngIf="state === TrainingAvailability.ARCHIVED" class="size-sm" fontSet="material-icons-outlined">inventory_2</mat-icon>
    <mat-icon *ngIf="state === TrainingAvailability.DRAFT" class="size-sm" fontSet="material-icons-outlined">note_alt</mat-icon>
    <span>{{ text }}</span>
  </span>
</ng-template>
